import React from "react";

import { MAX_SOURCE_HISTORY_DAYS } from "../../utils/composedForecastUtils";

interface SourceHistoryOverrideProps {
  /** The row's own days of history before the forecast; unset = the view's. */
  value?: number;
  onChange: (days: number | undefined) => void;
}

/** A source's own history before the forecast, in a view that has one: blank follows the view's setting at the top. */
const SourceHistoryOverride: React.FC<SourceHistoryOverrideProps> = ({ value, onChange }) => (
  <div className="flex flex-wrap items-center gap-x-2 gap-y-1">
    <input
      type="number"
      aria-label="Days of history before the forecast"
      value={value ?? ""}
      onChange={(e) => {
        const days = parseInt(e.target.value, 10);
        // Capped as typed, so a stray large number never saves (the read caps it again)
        onChange(days > 0 ? Math.min(days, MAX_SOURCE_HISTORY_DAYS) : undefined);
      }}
      min="1"
      max={MAX_SOURCE_HISTORY_DAYS}
      placeholder="View's"
      className="eai-input w-24 shrink-0 sm:w-32"
    />
    <span className="font-inter text-eai-body-xs text-eai-ink-faint">
      days before the main forecast starts (moves with the selected issue). Blank uses{" "}
      <span className="text-eai-ink-muted">History before the forecast</span> at the top.
    </span>
  </div>
);

export default SourceHistoryOverride;
